export const PLACE_ORDER = "PLACE_ORDER";
export const PND_CART_DETAILS = "PND_CART_DETAILS";
export const PND_PLACE_ORDER = "PND_PLACE_ORDER";
